import { useState } from 'react';

export function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-article-line text-background-50 text-base"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门爆料卡片</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 ml-11">精选全网最热爆料 · 一卡在手资讯全有</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/70 transition-all group cursor-pointer">
            <div className="h-44 relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Entertainment%20news%20concept%20with%20stage%20spotlight%20and%20shadow%20silhouette%2C%20warm%20theatrical%20red%20and%20gold%20tones%2C%20elegant%20abstract%20composition%2C%20editorial%20style%2C%20soft%20gradient%20background&width=600&height=420&seq=card-01&orientation=landscape"
                alt="娱乐圈顶流明星合约到期去向成谜"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                width="600"
                height="420"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-semibold rounded">娱乐圈</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                娱乐圈顶流明星合约到期去向成谜，三家经纪公司暗中角力
              </h3>
              <p className="text-xs text-foreground-500 mb-3 line-clamp-2">据可靠消息，某当红演员与原经纪公司合约即将到期，多家公司已开始秘密接触，条件包括天价签约费和股权激励。</p>
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span><i className="ri-time-line mr-1"></i>2小时前</span>
                <span><i className="ri-eye-line mr-1"></i>8.7万阅读</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/70 transition-all group cursor-pointer">
            <div className="h-44 relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Technology%20office%20building%20concept%20with%20abstract%20glass%20facade%20and%20digital%20data%20elements%2C%20warm%20charcoal%20and%20amber%20color%20scheme%2C%20corporate%20style%2C%20clean%20modern%20aesthetic&width=600&height=420&seq=card-02&orientation=landscape"
                alt="知名互联网公司大规模裁员传闻"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                width="600"
                height="420"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-semibold rounded">科技</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                知名互联网公司大规模裁员传闻发酵，内部员工匿名爆料细节
              </h3>
              <p className="text-xs text-foreground-500 mb-3 line-clamp-2">多个社交平台出现该公司员工匿名帖，声称裁员比例可能高达30%，涉及多个核心业务线。</p>
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span><i className="ri-time-line mr-1"></i>5小时前</span>
                <span><i className="ri-eye-line mr-1"></i>12.3万阅读</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/70 transition-all group cursor-pointer">
            <div className="h-44 relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Urban%20street%20scene%20at%20night%20with%20warm%20streetlight%20glow%2C%20abstract%20silhouettes%2C%20social%20event%20atmosphere%2C%20documentary%20style%20photography%2C%20soft%20focus%20background%20with%20bokeh%20lights&width=600&height=420&seq=card-03&orientation=landscape"
                alt="一线城市深夜发生群体事件"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                width="600"
                height="420"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-400 text-background-50 text-xs font-semibold rounded">社会</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                一线城市深夜发生群体事件，多段现场视频在社交平台快速传播
              </h3>
              <p className="text-xs text-foreground-500 mb-3 line-clamp-2">事件发生在某知名商圈，目击者称现场聚集数百人，警方已介入调查，具体情况有待官方通报。</p>
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span><i className="ri-time-line mr-1"></i>8小时前</span>
                <span><i className="ri-eye-line mr-1"></i>23.1万阅读</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/70 transition-all group cursor-pointer">
            <div className="h-44 relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stock%20market%20trading%20floor%20abstract%20concept%20with%20flowing%20data%20and%20candlestick%20patterns%2C%20warm%20gold%20and%20dark%20tones%2C%20financial%20illustration%2C%20professional%20business%20aesthetic&width=600&height=420&seq=card-04&orientation=landscape"
                alt="某上市公司财务数据遭质疑"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                width="600"
                height="420"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 bg-accent-400 text-background-50 text-xs font-semibold rounded">财经</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                某上市公司财务数据遭做空机构质疑，股价盘中一度暴跌超20%
              </h3>
              <p className="text-xs text-foreground-500 mb-3 line-clamp-2">知名做空机构发布长达80页的调查报告，直指该公司收入造假，公司紧急发布澄清公告但仍未能稳住股价。</p>
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span><i className="ri-time-line mr-1"></i>1天前</span>
                <span><i className="ri-eye-line mr-1"></i>31.5万阅读</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/70 transition-all group cursor-pointer">
            <div className="h-44 relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Sports%20stadium%20with%20dramatic%20lighting%2C%20athlete%20silhouette%2C%20competitive%20atmosphere%2C%20warm%20golden%20spotlight%20effect%2C%20sports%20illustration%20style%2C%20intense%20moment&width=600&height=420&seq=card-05&orientation=landscape"
                alt="国际赛事裁判争议判罚引发全球讨论"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                width="600"
                height="420"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-400 text-background-50 text-xs font-semibold rounded">体育</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                国际赛事裁判争议判罚引发全球讨论，多位退役球星公开质疑
              </h3>
              <p className="text-xs text-foreground-500 mb-3 line-clamp-2">比赛关键时刻的一次争议判罚成为热议焦点，社交媒体相关话题讨论量一夜突破百万。</p>
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span><i className="ri-time-line mr-1"></i>1天前</span>
                <span><i className="ri-eye-line mr-1"></i>18.6万阅读</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/70 transition-all group cursor-pointer">
            <div className="h-44 relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Government%20building%20abstract%20concept%20with%20flags%20and%20international%20relations%20theme%2C%20warm%20diplomatic%20atmosphere%2C%20professional%20news%20photography%20style%2C%20clean%20composition%20on%20neutral%20background&width=600&height=420&seq=card-06&orientation=landscape"
                alt="两国高层闭门会谈内容疑似外泄"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                width="600"
                height="420"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 bg-secondary-500 text-background-50 text-xs font-semibold rounded">国际</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                两国高层闭门会谈内容疑似外泄，涉及多项敏感贸易协定条款
              </h3>
              <p className="text-xs text-foreground-500 mb-3 line-clamp-2">匿名消息源向媒体透露了会谈的部分内容，其中关于关税调整的条款引发行业高度关注。</p>
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span><i className="ri-time-line mr-1"></i>2天前</span>
                <span><i className="ri-eye-line mr-1"></i>15.2万阅读</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/70 transition-all group cursor-pointer">
            <div className="h-44 relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Food%20safety%20inspection%20concept%20with%20kitchen%20scene%20and%20warning%20signs%2C%20warm%20amber%20lighting%2C%20documentary%20style%2C%20concerned%20consumer%20atmosphere%2C%20clean%20composition&width=600&height=420&seq=card-07&orientation=landscape"
                alt="连锁餐饮品牌后厨卫生问题再次被曝光"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                width="600"
                height="420"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-semibold rounded">社会</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                连锁餐饮品牌后厨卫生问题再次被曝光，监管部门介入全面排查
              </h3>
              <p className="text-xs text-foreground-500 mb-3 line-clamp-2">卧底记者拍摄的画面显示多处卫生隐患，品牌方连夜发布致歉声明并承诺全面整改。</p>
              <div className="flex items-center justify-between text-xs text-foreground-400">
                <span><i className="ri-time-line mr-1"></i>3天前</span>
                <span><i className="ri-eye-line mr-1"></i>28.9万阅读</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
            <i className="ri-vidicon-line text-background-50 text-base"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">视频爆料精选</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 ml-11">一手现场画面 · 真实呈现第一现场</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden group cursor-pointer hover:border-primary-200/70 transition-all">
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20recording%20night%20scene%20with%20blurry%20lights%2C%20citizen%20journalism%20style%2C%20urban%20night%20atmosphere%2C%20handheld%20camera%20aesthetic%2C%20warm%20streetlight%20tones%2C%20authentic%20documentary%20feel&width=600&height=420&seq=media-01&orientation=landscape"
                alt="市民手机拍摄夜店冲突现场"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                width="600"
                height="420"
              />
              <div className="absolute inset-0 bg-foreground-950/30 flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded">03:42</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                市民手机拍摄：某知名商圈深夜发生多人冲突，警方到场处置
              </h3>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span><i className="ri-play-circle-line mr-1"></i>12.6万次播放</span>
                <span>2天前</span>
              </div>
            </div>
          </div>

          <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden group cursor-pointer hover:border-primary-200/70 transition-all">
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Press%20conference%20scene%20with%20microphones%20and%20camera%20flashes%2C%20warm%20stage%20lighting%2C%20formal%20atmosphere%2C%20news%20briefing%20style%2C%20professional%20photography%2C%20spotlight%20effect&width=600&height=420&seq=media-02&orientation=landscape"
                alt="企业发布会现场回应争议"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                width="600"
                height="420"
              />
              <div className="absolute inset-0 bg-foreground-950/30 flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded">08:15</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                独家实录：涉事企业负责人首次公开回应近期争议风波
              </h3>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span><i className="ri-play-circle-line mr-1"></i>26.3万次播放</span>
                <span>3天前</span>
              </div>
            </div>
          </div>

          <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden group cursor-pointer hover:border-primary-200/70 transition-all">
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Drone%20aerial%20footage%20of%20urban%20traffic%20jam%2C%20warm%20sunset%20lighting%2C%20city%20skyline%2C%20helicopter%20perspective%2C%20news%20coverage%20style%2C%20dramatic%20wide%20shot&width=600&height=420&seq=media-03&orientation=landscape"
                alt="航拍城市重大突发事件现场"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                width="600"
                height="420"
              />
              <div className="absolute inset-0 bg-foreground-950/30 flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded">01:58</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                无人机航拍：某地发生重大突发事件，相关部门紧急响应
              </h3>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span><i className="ri-play-circle-line mr-1"></i>41.7万次播放</span>
                <span>5天前</span>
              </div>
            </div>
          </div>

          <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden group cursor-pointer hover:border-primary-200/70 transition-all">
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Hidden%20camera%20investigative%20journalism%20concept%2C%20dim%20lighting%20with%20warm%20spotlight%2C%20detective%20atmosphere%2C%20documentary%20film%20style%2C%20mysterious%20undercover%20investigation%20theme&width=600&height=420&seq=media-04&orientation=landscape"
                alt="暗访调查视频揭露行业内幕"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                width="600"
                height="420"
              />
              <div className="absolute inset-0 bg-foreground-950/30 flex items-center justify-center">
                <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded">12:30</span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                深度暗访：记者卧底三个月，揭露某行业不为人知的潜规则
              </h3>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span><i className="ri-play-circle-line mr-1"></i>58.2万次播放</span>
                <span>1周前</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const faqData = [
  {
    q: '爆料网和51爆料网、91爆料网是什么关系？',
    a: '爆料网是一个独立的第三方资讯聚合平台，我们聚合了包括51爆料网、91爆料网等在内的多个热门爆料来源的优质内容。我们并非这些网站的附属或镜像站，而是以独立编辑立场为读者筛选和呈现最具价值的每日吃瓜爆料内容。',
  },
  {
    q: '9-11爆料网打不开怎么办？如何获取最新可用地址？',
    a: '当9-11爆料网出现无法访问的情况时，您可以直接在爆料网首页查看同步更新的每日爆料内容。本站提供多重备用入口和最新网址更新服务，建议您收藏爆料网首页作为长期稳定的访问入口，或下载爆料网App以获取更加稳定的访问体验。',
  },
  {
    q: '爆料网的内容更新频率是怎样的？',
    a: '爆料网的编辑团队实行7×24小时轮班制，确保全天候不间断更新。每日更新量约130-150条，覆盖娱乐圈、社会热点、科技财经、体育赛事、国际时事等多个领域。所有内容均经过编辑审核，在时效性与真实性之间取得最佳平衡。',
  },
  {
    q: '如何在爆料网上投稿爆料线索？',
    a: '您可以通过页面顶部的"我要爆料"按钮或"联系我们"专区提交线索。我们的编辑团队会对每一条投稿进行认真审核，确认属实后会在爆料网上发布并标注来源。我们承诺保护爆料人的隐私信息，绝不对外透露投稿人身份。',
  },
  {
    q: '爆料网App有哪些特色功能？',
    a: '爆料网App（支持iOS和Android）提供与网页版同步的完整爆料内容，并额外支持推送通知、离线阅读、夜间模式和个性化关注设置。推送通知确保您第一时间收到突发爆料提醒，离线缓存功能让您即使在没有网络的情况下也能畅享精彩内容。',
  },
];

export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-question-line text-background-50 text-base"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">常见疑问解答</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 ml-11">关于爆料网 · 你想知道的都在这里</p>

        <div className="max-w-3xl ml-11 space-y-3">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left hover:bg-background-100/50 transition-colors cursor-pointer"
              >
                <h3 className="font-heading text-base md:text-lg text-foreground-900 pr-4">{item.q}</h3>
                <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center transition-all ${
                  openIndex === i ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-100 text-foreground-400'
                }`}>
                  <i className="ri-add-line text-lg"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-4 md:px-5 pb-4 md:pb-5 animate-fade-in">
                  <div className="border-t border-background-200/60 pt-4">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}